export const PROCESSING_CODE_TYPES = {
  SHIPMENT: "SHIPMENT",
  RETURN: "RETURN",
  EXCHANGE: "EXCHANGE",
};

export const MATERIAL_CATEGORIES = {
  HARDWARE: "HARDWARE",
  ACCESSORY: "ACCESSORY",
};

export const PROCESSING_CODES = {
  [PROCESSING_CODE_TYPES.SHIPMENT]: {
    [MATERIAL_CATEGORIES.HARDWARE]: "ZHWS",
    [MATERIAL_CATEGORIES.ACCESSORY]: "ZHWA",
  },
  [PROCESSING_CODE_TYPES.RETURN]: {
    [MATERIAL_CATEGORIES.HARDWARE]: "ZZHR",
    [MATERIAL_CATEGORIES.ACCESSORY]: "ZHAR",
  },
  [PROCESSING_CODE_TYPES.EXCHANGE]: {
    [MATERIAL_CATEGORIES.HARDWARE]: "ZZHS",
    [MATERIAL_CATEGORIES.ACCESSORY]: "ZZAE",
  },
};

export const getProcessingCode = (type, category) => {
  return PROCESSING_CODES[type]?.[category] || "";
};

export const getMaterialCategory = (code) => {
  for (const [, categories] of Object.entries(PROCESSING_CODES)) {
    for (const [category, processingCode] of Object.entries(categories)) {
      if (processingCode === code) {
        return category;
      }
    }
  }
  return null;
};

export const getExchangeCode = (processingCode) => {
  const category = getMaterialCategory(processingCode);
  if (!category) {
    return processingCode;
  }
  return getProcessingCode(PROCESSING_CODE_TYPES.EXCHANGE, category);
};

export const getReturnCode = (processingCode) => {
  const category = getMaterialCategory(processingCode);
  if (!category) {
    return processingCode;
  }
  return getProcessingCode(PROCESSING_CODE_TYPES.RETURN, category);
};
